import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { align: "right" }

import { storeToRefs } from 'pinia'
import BaseModal from './wrappers/BaseModal.vue'
import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '../store/useUserStore'
import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalTravelMileage',
  props: {
    modelValue: { type: Boolean },
    stopTravel: { type: Boolean }
  },
  emits: ["confirmTravel", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const show = useModelWrapper(props, emit)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

const confirm = () => {
  emit('confirmTravel', true)
  show.value = false
}
const user = storeToRefs(useUserStore())
const message = computed(() => {
  switch (user.language.value) {
    case 'fr_CA': //french is always km
      if (props.stopTravel)
        return 'Les activités de voyage supérieures à 640 ne sont pas autorisées. Veuillez contacter la direction pour toute question.'

      return 'Vous avez saisi plus de 160 km pour ce déplacement, souhaitez-vous poursuivre?'
    default:
      if (props.stopTravel)
        return `Travel Activity over ${
          user.distance.value == 'miles' ? 400 : 640
        } is not permitted- Please Contact Management for any questions`

      return `You have entered more than ${user.distance.value == 'miles' ? 100 : 160} ${
        user.distance.value
      } for this travel, do you want to proceed?`
  }
})

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(show),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('activities.travel')), 1)
    ]),
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(message.value), 1)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_q_btn, {
          flat: "",
          "no-caps": "",
          class: "text-grey-7",
          label: label('cancel')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ]),
        (!_ctx.stopTravel)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (confirm())),
              color: "primary",
              label: label('continue')
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})